import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { useForm } from "react-hook-form";
import { districtValidationForm } from "../../utils/validationSchema";
import DistrictForm from "./DistrictForm";
import Form from "../../layouts/Form";

const CreateDistrict = (props: any) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    setError,
    getValues,
    clearErrors
  } = useForm<any>({
    resolver: yupResolver(districtValidationForm),
  });

  const { handleCreate, isLoading } = props;
  return (
    <Form
      handleSubmit={handleSubmit}
      handleFormSubmit={handleCreate}
      setError={setError}
      buttonLabel={"Create"}
      isLoading={isLoading}
    >
      <DistrictForm
        clearErrors={clearErrors}
        errors={errors}
        register={register}
        setValue={setValue}
        getValues={getValues}
      />
    </Form>
  );
};

export default CreateDistrict;
